<template>
  <div>
    <a-modal
      :wrapClassName="disabeld ? 'ps-see-form-modal' : ''"
      :title="title"
      :width="disabeld ? '560px' : '40%'"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      :keyboard="false"
      @cancel="handleCancel"
      @ok="submit"
      :ok-text="saveText"
      cancel-text="取消"
    >
      <div>
        <a-form-model
          ref="formRef"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="年份" prop="year">
            <a-date-picker
              placeholder="请选择年份"
              v-model="form.year"
              :open="yearPickerVisible"
              :locale="locale"
              :format="'YYYY'"
              mode="year"
              @openChange="handleYearPickerOpenChange"
              @panelChange="handleYearSelect"
              @change="handleClearYear"
              :disabled="disabeld"
            />
          </a-form-model-item>
          <a-form-model-item label="年度总结报告" prop="file">
            <template v-if="disabeld">
              <span
                v-if="seeFilePath"
                class="ps-see-file-link"
                @click.stop="openFilePreview"
              >{{ seeFileName }}</span>
              <span v-else>--</span>
            </template>
            <a-upload
              v-else
              :file-list="fileList"
              :remove="handleFileRemove"
              :before-upload="beforeFileUpload"
              :showUploadList="{
                showRemoveIcon: true,
                showPreviewIcon: true,
              }"
              accept=".pdf"
              @preview="handleFilePreview"
            >
              <a-button :loading="uploading">
                <a-icon type="upload" /> 上传报告
              </a-button>
              <div class="upload-hint">注：可上传pdf格式的文件</div>
            </a-upload>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
    <!-- 自带预览弹窗（无父级监听时使用） -->
    <a-modal
      :visible="showiframe"
      :footer="null"
      :closable="false"
      :maskClosable="false"
      :keyboard="true"
      :zIndex="5000"
      width="960px"
      wrapClassName="ps-file-preview-modal"
      :destroyOnClose="true"
      :dialogStyle="{ top: '40px', paddingBottom: '0' }"
      @cancel="closeFilePreview"
    >
      <div class="ps-file-preview-body">
        <newpreview
          :previewUrl="previewUrl"
          dialogTitle="年度总结报告预览"
          @closePreview="closeFilePreview"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { postAction, putAction, fileUpdate } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import newpreview from "@/components/common/newpreviews";
moment.locale("zh-cn");

const MAX_FILE_COUNT = 1;
const SUPPORTED_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/jpg",
  "video/mp4",
];

export default {
  components: { newpreview },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      form: {
        applyId: "",
        year: "",
      },
      yearPickerVisible: false,
      rules: {
        year: [
          {
            required: true,
            message: "请选择年份",
            validator: (rule, value, callback) => {
              if (this.form.year != "") {
                callback();
              } else {
                callback(new Error("请选择年份"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      zh_CN,
      locale,
      applyType: 2,
      mode: "",
      title: "",
      fileList: [],
      uploading: false,
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
      showiframe: false,
      previewUrl: "",
    };
  },
  computed: {
    seeFilePath() {
      const f = this.fileList && this.fileList[0];
      return (f && (f.path || f.url)) || "";
    },
    seeFileName() {
      const f = this.fileList && this.fileList[0];
      return (f && f.name) || "年度总结报告";
    },
  },
  methods: {
    openFilePreview() {
      this.handleFilePreview({
        path: this.seeFilePath,
        url: this.seeFilePath,
        name: this.seeFileName,
      });
    },
    closeFilePreview() {
      this.showiframe = false;
      this.previewUrl = "";
    },
    handleFilePreview(file) {
      const path =
        (file && (file.path || file.url)) || this.seeFilePath || "";
      if (!path) {
        this.$message.info("暂无文件可预览");
        return;
      }
      this.previewUrl = path;
      // 本组件高层 a-modal（zIndex:5000）打开，盖在查看弹窗之上
      this.$nextTick(() => {
        this.showiframe = true;
      });
    },
    init(mode, record, taskId, detailId) {
      this.mode = mode;
      this.visible = true;
      this.disabeld = false;
      this.saveText = "保存";
      this.resetForm();

      if (mode === "add") {
        this.title = "添加年度计划";
        this.form.applyId = record.id;
        this.form.year = new Date().getFullYear().toString();
      } else if (mode == "edit") {
        this.title = "编辑年度计划";
        this.form = {
          applyId: record.applyId,
          id: record.id,
          year: record.year,
        };
        this.fillFileList(record);
        this.teacherdata = record;
      } else if (mode === "audit-edit") {
        this.title = "编辑年度计划";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          applyId: record.applyId,
          id: record.id,
          year: record.year,
        };
        this.fillFileList(record);
      } else {
        this.disabeld = true;
        this.title = "查看年度计划";
        this.saveText = "关闭";
        this.form = {
          applyId: record.applyId,
          id: record.id,
          year: record.year,
        };
        this.fillFileList(record);
      }
    },

    fillFileList(record) {
      this.fileList = [];
      if (!record || !record.filePath) return;
      this.fileList = [
        {
          path: record.filePath,
          url: record.filePath,
          name: record.fileName || "年度总结报告",
          uid: -1,
          status: "done",
        },
      ];
    },

    resetForm() {
      this.form = {
        applyId: "",
        year: "",
      };
      this.fileList = [];
      this.showiframe = false;
      this.previewUrl = "";
    },

    handleFileRemove(file) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    beforeFileUpload(file) {
      if (!this.isFileTypeSupported(file)) {
        this.$message.error("不支持的文件类型");
        return false;
      }

      if (this.fileList.length >= MAX_FILE_COUNT) {
        this.$message.error(`年度报告只能上传${MAX_FILE_COUNT}个文件`);
        return false;
      }

      this.uploadFile(file);
      return false;
    },

    isFileTypeSupported(file) {
      return SUPPORTED_FILE_TYPES.includes(file.type);
    },

    async uploadFile(file) {
      this.uploading = true;
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("biz", "linxuan");

        const res = await fileUpdate(formData);
        if (res.code === 200) {
          this.fileList.push({
            path: res.message,
            url: res.message,
            name: file.name,
            name1: res.message,
            uid: file.uid,
            status: "done",
          });
          this.$message.success("上传成功");
        } else {
          this.$message.error(res.message || "上传失败");
        }
      } catch (error) {
        this.$message.error("上传失败");
        console.error(error);
      } finally {
        this.uploading = false;
      }
    },

    handleCancel() {
      this.visible = false;
      this.resetForm();
    },

    async submit() {
      if (this.disabeld) {
        this.visible = false;
        return;
      }
      try {
        await this.$refs.formRef.validate();

        if (this.fileList.length === 0) {
          this.$message.error("请上传年度总结报告");
          return;
        }

        this.confirmLoading = true;
        const params = this.prepareSubmitData();
        let apiUrl =
          this.mode === "add"
            ? "/lxbase/lxAnnualPlan/add"
            : this.mode === "edit"
            ? "/lxbase/lxAnnualPlan/edit"
            : "/audit/lxAuditTask/reSubmitTask";
        if (
          this.teacherdata?.status == "0" ||
          this.teacherdata?.status == "1" ||
          this.teacherdata?.status == "4" ||
          this.teacherdata?.status == "3" ||
          (this.teacherdata?.status == "2" && this.teacherdata?.operation)
        ) {
          apiUrl = "/audit/lxAuditTask/editTaskAndDetail";
        }
        const action = this.mode === "edit" ? putAction : postAction;
        const auditParams = {
          taskId: this.taskId,
          afterJson: JSON.stringify({ ...this.prepareSubmitData() }),
          detailId: this.detailId,
        };
        let auditParams1 = {
          id: this.teacherdata?.taskId,
          applicationData: JSON.stringify(this.$nullToEmpty(params)),
        };
        if (this.teacherdata?.status == "4") {
          auditParams1.auditState = "1";
        }
        let res = "";
        if (
          this.teacherdata?.status == "0" ||
          this.teacherdata?.status == "1" ||
          this.teacherdata?.status == "4" ||
          this.teacherdata?.status == "3"
        ) {
          res = await action(apiUrl, auditParams1);
        } else {
          res = await action(
            apiUrl,
            this.mode === "audit-edit" ? auditParams : params
          );
        }

        if (res.code == 200) {
          this.$message.success(res.message || `${this.title}成功`);
          this.visible = false;
          this.$emit("addAnnualPlan");
        } else {
          this.$message.error(res.message || `${this.title}失败`);
        }
      } catch (error) {
        console.error("Submit error:", error);
      } finally {
        this.confirmLoading = false;
      }
    },

    prepareSubmitData() {
      const params = { ...this.form, applyType: this.applyType };

      if (this.fileList.length > 0) {
        params.filePath = this.fileList[0].path;
        params.fileName = this.fileList[0].name;
      }

      if (typeof params.year === "object" && params.year !== "") {
        params.year = new Date(params.year).getFullYear().toString();
      }

      return params;
    },

    handleYearPickerOpenChange(open) {
      this.yearPickerVisible = open;
    },

    handleYearSelect(value) {
      this.form.year = moment(value).format("YYYY");
      this.yearPickerVisible = false;
      this.$refs.formRef.clearValidate("year");
    },

    handleClearYear() {
      this.form.year = "";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}

.upload-hint {
  margin-top: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

.ps-see-file-link {
  color: #e5914b;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  word-break: break-all;

  &:hover {
    color: #c46d2a;
  }
}

.ps-file-preview-body {
  height: 72vh;
  margin: -24px;
}
</style>

<style lang="scss">
.ps-file-preview-modal {
  .ant-modal-body {
    padding: 0;
  }
}
</style>
